module.exports = __webpack_public_path__ + "img/img3.6d6d438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img3.jpg
// module id = 327
// module chunks = 0